.group {
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.legend {
  margin-bottom: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: var(--tuna-typography-fontWeight-bold);
  color: var(--tuna-content-primary);
}

.option {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  min-height: 44px;
  padding: var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
}

.optionText {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.optionLabel {
  color: var(--tuna-content-primary);
}

.helper {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.guard {
  margin: 0;
  color: var(--tuna-content-primary);
}
